// 사용자 주석 액션 — 정의 목록 · 연결별 영역(연결할 때 영역 조회 쿼리를 돌려 리덕스에 둔다, docs/features/32-user-comment.md)
import { listDefs, fetchAreas } from '../../services/userComments';

export const UCMT_DEFS_LOADED = 'UCMT_DEFS_LOADED';
export const UCMT_AREAS_START = 'UCMT_AREAS_START';
export const UCMT_AREAS_DONE = 'UCMT_AREAS_DONE';
export const UCMT_AREAS_RESET = 'UCMT_AREAS_RESET';

/** 정의 목록을 다시 받고, 영역은 비운다 — 매핑·쿼리가 바뀌었을 수 있다(App 이 연결된 것부터 다시 받는다) */
export const loadUserCommentDefs = () => async (dispatch) => {
    try {
        const r = await listDefs();
        dispatch({ type: UCMT_AREAS_RESET });
        dispatch({ type: UCMT_DEFS_LOADED, payload: r.defs || [] });
    } catch (_e) {
        // 로그인 전·서버 없음 — 사용자 주석 없이 돈다
        dispatch({ type: UCMT_DEFS_LOADED, payload: [] });
    }
};

const inFlight = new Set();
export const loadUserCommentAreas = (connectionId) => async (dispatch) => {
    if (!connectionId || inFlight.has(connectionId)) return;
    inFlight.add(connectionId);
    dispatch({ type: UCMT_AREAS_START, connectionId });
    try {
        const r = await fetchAreas(connectionId);
        dispatch({ type: UCMT_AREAS_DONE, connectionId, areas: r.areas || [], errors: r.errors || [] });
    } catch (e) {
        dispatch({ type: UCMT_AREAS_DONE, connectionId, areas: [], errors: [], error: (e && e.message) || 'error' });
    } finally {
        inFlight.delete(connectionId);
    }
};
